import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import PROHIBITED_ITEMS_SECTIONS from '../content/prohibitedItems'
import { withLinks } from '../lib/termsRender'

// /prohibited-items — sections carried over word for word from the old Terms
// (see src/content/prohibitedItems.js). Same styling as /terms.
export default function ProhibitedItems() {
const navigate = useNavigate()

return (
<div>
<Header />
<div className="container" style={{ maxWidth: 700, padding: '2rem 1rem', lineHeight: 1.8 }}>
<button className="btn btn-ghost btn-sm" onClick={() => window.history.length > 1 ? navigate(-1) : window.close()} style={{ marginBottom: '1rem' }}>← Back</button>
<h1 style={{ fontSize: 28, fontWeight: 600, marginBottom: '2rem' }}>Prohibited Items &amp; Safety Policy</h1>
{PROHIBITED_ITEMS_SECTIONS.map(s => (
<div key={s.title}>
<h2 style={{ fontSize: 20, fontWeight: 600, margin: '2rem 0 10px', color: 'var(--navy)' }}>{s.title}</h2>
<p style={{ color: 'var(--text-muted)', fontSize: 14, margin: '0 0 8px' }}>{withLinks(s.body)}</p>
</div>
))}
</div>
</div>
)
}
